var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0588 9.94118H2C1.44772 9.94118 1 10.3889 1 10.9412V24C1 24.5523 1.44772 25 2 25H17.5686C18.1209 25 18.5686 24.5523 18.5686 24V10.9412C18.5686 10.3889 18.1209 9.94118 17.5686 9.94118H16.0588ZM16.0588 9.94118C16.0588 6.01961 14.932 1.12549 9.91239 1C4.89279 1.12549 3.5098 6.33333 3.5098 9.94118",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBtn);
export default __webpack_public_path__ + "static/media/LockBtn.371d01d77230dc021e4fb5646c105244.svg";
export { ForwardRef as ReactComponent };